<template>
  <div :class="[wrapperClass]" class="ellipsis-loader">
    <div v-if="text" :class="textClass" class="ellipsis-loader__text">
      {{ text }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: '',
  },
  wrapperClass: {
    type: String,
    default: '',
  },
  textClass: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
.ellipsis-loader {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
}

.ellipsis-loader-text {
  color: var(--tw-color-gray-500);
}
.ellipsis-loader-text-light {
  color: var(--tw-color-gray-300);
}
.ellipsis-loader-launched-app {
  transform: translate(-50%, calc(-50% - 44px));
}
</style>
